import { useContext } from 'react';
import { ReferralStoreContext } from './ReferralStoreContext';
import type { ReferralStoreContextValue } from './ReferralStoreContext';

export const useReferralStore = (): ReferralStoreContextValue => {
  const context = useContext(ReferralStoreContext);
  if (context === undefined) {
    throw new Error('useReferralStore must be used within a ReferralStoreProvider');
  }
  return context;
};

